import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/landing';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  const reduce = useReducedMotion();
  return <section id="preguntas" className="scroll-mt-16 border-t border-line bg-night" data-id="element-76" data-mp="1gitv82azasio">
      <div className="mx-auto grid max-w-6xl gap-4 px-5 py-10 md:px-6 md:py-16 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16 lg:py-20" data-id="element-77" data-mp="249g601cdaqwd">
        <h2 className="font-display text-xl text-cream md:text-3xl lg:text-4xl" data-id="element-78" data-mp="289q9n7cot582">
          Preguntas frecuentes
        </h2>

        <div className="border-t border-line" data-id="element-79" data-mp="1uj4o1avumh6h">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          const id = `faq-${i}`;
          return <div key={f.question} className="border-b border-line" data-id="element-80" data-mp="2n7a8rxmwk66b" data-mpi={i}>
                <h3 data-id="element-81" data-mp="2rzag4b5ay1cx">
                  <button type="button" aria-expanded={isOpen} aria-controls={id} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 py-3.5 text-left text-[15px] text-cream transition-colors duration-150 hover:text-gold-light focus:outline-none focus-visible:text-gold-light md:py-5 md:text-lg" data-id="element-82" data-mp="2rztwhnfb0hou">
                    {f.question}
                    <PlusIcon aria-hidden="true" className={`h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-83" data-mp="1oi8ar1ydbdp0" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-84" data-mp="1skd0vqplxs6w">
                  {isOpen && <motion.div id={id} initial={reduce ? false : {
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={reduce ? {
                opacity: 0
              } : {
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-85" data-mp="35yhllxcyxis">
                      <p className="max-w-2xl pb-4 text-sm leading-relaxed text-muted md:text-base" data-id="element-86" data-mp="2867vlt98lng2">
                        {f.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}